import { GRChat } from '../../../interfaces/lpsShow';
import { ILpsShowThankYouInitialData } from '../../../interfaces/lpsShowThankYou';
import { GrChatStatus } from '../../../enums/grChatStatus';
import { CryptoName } from '../../../enums/cryptoName';

class LpsShowThankYouConfig {
  public getInitialData(): ILpsShowThankYouInitialData {
    return window.grLpsInitialData as ILpsShowThankYouInitialData;
  }

  public getGRChatData(): GRChat {
    return (
      this.getInitialData().grChat ?? {
        status: GrChatStatus.Disabled,
        urlParams: null,
      }
    );
  }

  public getGrChatStatus(): GrChatStatus {
    return this.getGRChatData().status;
  }

  public getGrChatUrlParams(): string {
    return this.getGRChatData().urlParams;
  }

  public isGrChatEnabled(): boolean {
    return this.getGrChatStatus() === GrChatStatus.Enabled;
  }

  public getCrypto(): string {
    return this.getInitialData().crypto;
  }

  public isSMB(): boolean {
    return this.getCrypto() === CryptoName.Getresponse;
  }

  public isMAX(): boolean {
    return !this.isSMB();
  }

  public getLandingPageEncodedId(): string {
    return this.getInitialData().landingPageEncodedId;
  }
}

export const LPSThankYouData = new LpsShowThankYouConfig();
